import { layout2 } from "../../../../utils/styles";
import React from "react";

export const ChapterTitle = ({chapter: ch, fontFamily}) => {
  return (<>
    <div style={{color: 'black', fontSize: '24px', fontFamily: fontFamily||'Roboto-Bold', margin: '10px 0 30px 0'}} className={'lsnGroupTitle'}>{ch.title}</div>
  </>)
};
